<div class="modal" [ngClass]="{'is-active': mostrar}" >
  <div class="modal-background" (click)="toggle()"></div>
  <div class="modal-content">
    <!-- Any other Bulma elements you want -->
    <div class="card" style="width: 100%; border-radius: 1em; background: #222;">
        <div class="card-content">
            <div class="columns is-multiline is-mobile">

                <div class="column is-3-desktop is-4-tablet is-6-mobile hub-principal" *ngFor="let item of menu; let i=index">
                    <a href="#" title="{{item.titulo}}" class="hub-item" routerLink="{{item.path}}" routerLinkActive="active">
                        <figure class="image " style="height: auto; width: 100%; ">
                           <i class="{{item.icono}}" style="font-size: 100px"></i>                            
                        </figure>
                        <span class="is-hidden-mobile">{{item.titulo}}</span>
                    </a>
                </div>                
            </div>
            
        </div>
    </div>
  </div>
  <button class="modal-close" (click)="toggle()"></button>
</div>